/**
 * Cache-key prefix the customers (patients) list page registers its
 * ListQueryService entries under. The store's mutation effects invalidate this
 * prefix so the list refreshes after a save/update, while embedded lists (which
 * read the NgRx collection) are untouched.
 */
export const CUSTOMER_LIST_QUERY_PREFIX = 'customer|list|';
